var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.032,
    height: 23.246,
    viewBox: "0 0 24.032 23.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map",
    transform: "translate(0 -8.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7106",
    "data-name": "Path 7106",
    d: "M156.939,205.1a.939.939,0,0,1-.939-.939V198.75a.939.939,0,1,1,1.878,0v5.415A.939.939,0,0,1,156.939,205.1Z",
    transform: "translate(-148.678 -180.542)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7107",
    "data-name": "Path 7107",
    d: "M23.094,120.438a.939.939,0,0,0-.939.939v4.454a.934.934,0,0,1-.519.84l-.011.006-5.438,2.813a.943.943,0,0,1-.835,0l-5.831-2.915a2.83,2.83,0,0,0-2.519,0l-.017.008-3.756,1.972a.939.939,0,0,1-1.352-.843v-8.944a.934.934,0,0,1,.519-.84l.011-.006,5.438-2.813a.943.943,0,0,1,.835,0l3.524,1.762a.939.939,0,0,0,.84-1.679l-3.524-1.762a2.83,2.83,0,0,0-2.519,0l-.011.006-5.44,2.814A2.8,2.8,0,0,0,0,118.764v8.944a2.816,2.816,0,0,0,4.076,2.519l.017-.008,3.756-1.972a.943.943,0,0,1,.833,0l5.831,2.915a2.83,2.83,0,0,0,2.519,0l.011-.006,5.44-2.814a2.8,2.8,0,0,0,1.55-2.516v-4.454A.939.939,0,0,0,23.094,120.438Z",
    transform: "translate(0 -99.839)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7108",
    "data-name": "Path 7108",
    d: "M317.878,274.868V269.7a.939.939,0,1,0-1.878,0v5.172a.939.939,0,1,0,1.878,0Z",
    transform: "translate(-301.167 -248.158)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_310",
    "data-name": "Ellipse 310",
    cx: 0.953,
    cy: 0.953,
    r: 0.953,
    transform: "translate(18.213 12.076)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7109",
    "data-name": "Path 7109",
    d: "M316.694,8.377A4.7,4.7,0,0,0,312,13.071c0,1.445.78,3.391,2.318,5.781a2.82,2.82,0,0,0,4.752,0c1.538-2.391,2.318-4.336,2.318-5.781A4.7,4.7,0,0,0,316.694,8.377Zm.8,9.459a.943.943,0,0,1-1.594,0c-1.3-2.024-2.019-3.717-2.019-4.766a2.816,2.816,0,0,1,5.633,0C319.51,14.12,318.793,15.812,317.491,17.836Z",
    transform: "translate(-297.355)",
    fill: "#0a64f9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.7eed5fb31cb4f8274af2686c586495a5.svg";
export { ForwardRef as ReactComponent };